module.exports = __webpack_public_path__ + "img/SCS-Text-Logo.1beb8b45.png";